class productCountdown extends HTMLElement {
    constructor() {
        super();

        this.productTemplate        = this._isProductTemplate()
        this.collectionTemplate     = this._isCollectionTemplate()
        this.elementWrapper         = '.countdown'
        this.countdownWrapper       = '.countdown-wrapper';
        this.countdownDiv           = '.coming-soon--countdown';
        this.dateAttribute          = 'data-coming-date';
        this.notifyForm             = '.notify_form';

        // Notify ME

        this.dom = null;
        //Oggetti DOM
        this.form = null;
        this.formObject = {
            email: null,
            checkPrivacy: null,
        };

        this.submitButton = null;
        this.bisResponseError = null;
        this.bisResponseSuccess = null;

        this.cssClassError = 'fld-error'; // CSS Class for error message
        this.cssInputClassError = 'fld-error'; // CSS Class for error message
        this.cssHideClass = "hide"; // CSS Class for error message

        // Get DOM elements
        this.form = null;
        this.submitButton = null;
        this.acceptsMarketing = null; // Checkbox Iscrizione alla newsletter
        this.bisResponseError = null;
        this.bisResponseSuccess = null;

        // IDs per cui richiedere il Back In Stock
        this.idProduct = null; // ID univico del prodotto
        this.idVariant = null; // ID univoco della variante
        this.formObject.email = null;
        this.formObject.checkPrivacy = null;

        // Initialize
/*         if (this.productTemplate) {
            this.initNotifyMe();
        } */

        var comingSoonDiv = this.querySelector(this.countdownWrapper);
        this.makeTimer(comingSoonDiv);
    }

    _isProductTemplate(){
        if (document.querySelector("body.template-product")) return true;
        else return false;
    }

    _isCollectionTemplate(){
        if (document.querySelector("body.template-collection") || document.querySelector("body.template-search")) return true;
        else return false;
    }

    makeTimer(currentComingSoonDiv) {
        const interval = setInterval(() => {
            var endTime = new Date(currentComingSoonDiv.querySelector(this.countdownDiv).getAttribute(this.dateAttribute));
            var now = new Date();

            var offsetHour = now.getUTCHours();
            var nowUtc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), offsetHour, now.getUTCMinutes(), now.getUTCSeconds());
            endTime = (Date.parse(endTime) / 1000);
            now = (Date.parse(nowUtc) / 1000);

            if(endTime > now) {

                if(this.collectionTemplate) {
                    currentComingSoonDiv.closest('.product-card-wrapper').classList.add("ProductItem--countdown");
                } else if(this.productTemplate) {
                    document.body.classList.add("product-countdown");
                }

                var timeLeft = endTime - now;
                var days = Math.floor(timeLeft / 86400);
                var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
                var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
                var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

                if (days == 0 && hours == 0 && minutes == 0 && seconds == 1) {
                    location.reload();
                }

                if (days < "10") days = "0" + days;
                if (hours < "10") hours = "0" + hours;
                if (minutes < "10") minutes = "0" + minutes;
                if (seconds < "10") seconds = "0" + seconds;

                currentComingSoonDiv.querySelector(".days").innerHTML = "<div class='countdown-black-box tw-inline'><span class='tw-font-bold'>" + days + "</span></div>";
                currentComingSoonDiv.querySelector(".days").innerHTML += (Antonioli.settings.template == 'product') ? "<span>" + window.Antonioli.languages.countdownDays + "</span>" : "<span>" + window.Antonioli.languages.countdownDays + "</span>";

                currentComingSoonDiv.querySelector(".hours").innerHTML = "<div class='countdown-black-box tw-inline'><span class='tw-font-bold'>" + hours + "</span></div>";
                currentComingSoonDiv.querySelector(".hours").innerHTML += (Antonioli.settings.template == 'product') ? "<span>" + window.Antonioli.languages.countdownHours + "</span>" : "<span>" + window.Antonioli.languages.countdownHours + "</span>";

                currentComingSoonDiv.querySelector(".minutes").innerHTML = "<div class='countdown-black-box tw-inline'><span class='tw-font-bold'>" + minutes + "</span></div>";
                currentComingSoonDiv.querySelector(".minutes").innerHTML += (Antonioli.settings.template == 'product') ? "<span data-desktop='" + window.Antonioli.languages.countdownMinutes + "'>" + window.Antonioli.languages.countdownMinutesShort + "</span>" : "<span>" + window.Antonioli.languages.countdownMinutesShort + "</span>";

                currentComingSoonDiv.querySelector(".seconds").innerHTML = "<div class='countdown-black-box tw-inline'><span class='tw-font-bold'>" + seconds + "</span></div>";
                currentComingSoonDiv.querySelector(".seconds").innerHTML += (Antonioli.settings.template == 'product') ? "<span data-desktop='" + window.Antonioli.languages.countdownSeconds + "'>" + window.Antonioli.languages.countdownSecondsShort + "</span>" : "<span>" + window.Antonioli.languages.countdownSecondsShort + "</span>";

                //if(this.productTemplate) currentComingSoonDiv.closest('.Container').querySelector('#spinner').classList.add("hidden"); // Spinner
                currentComingSoonDiv.closest('.countdown').classList.remove("hidden");

            } else if (endTime < now) {
                
                clearInterval(interval);

                if(this.productTemplate) {

                    if(window.product.productAvailable == true ) {
                        //currentComingSoonDiv.closest('.Container').querySelector('#spinner').classList.add("hidden"); // Spinner
                        document.querySelector('.product-form__input').classList.remove("tw-hidden");
                    } else {
                        // out of stock < 1 minuto

                        //currentComingSoonDiv.closest('.Container').querySelector('#spinner').classList.remove("hidden"); // Spinner
                        currentComingSoonDiv.closest('.product__info-container').querySelector('.countdown-label').classList.remove("tw-hidden");

                        function waitOneMinute() {
                            var seconds = 20;
                            function tick() {
                                seconds--;
                                if (seconds > 0) {
                                    setTimeout(tick, 1000);
                                } else {
                                    location.reload();
                                }
                            }
                            tick();
                        }
                        waitOneMinute();

                    }

                } else {
                    document.querySelectorAll('.countdown-label').forEach(elem => elem.classList.remove("tw-hidden"));
                }
            }

        }, 1000);
    }

    initNotifyMe () {
        this.dom = $(document).find(this.notifyForm);

        // Get DOM elements
        this.form = this.dom.find('form');
        this.submitButton = this.dom.find('button[type="submit"]');
        this.acceptsMarketing = this.dom.find('.newsletter.notify_form__checkbox'); // Checkbox Iscrizione alla newsletter
        this.bisResponseError = this.dom.find ('.BIS_response_error');
        this.bisResponseSuccess = $(document).find('.BIS_response_success');

        // IDs per cui richiedere il Back In Stock
        this.idProduct = this.dom.data('product-id'); // ID univico del prodotto
        this.idVariant = this.dom.data('first-variant'); // ID univoco della variante
        this.formObject.email = this.form.find('input[name="contact[email]"]');
        this.formObject.checkPrivacy = $('input[name="contact[checkPrivacy]"]');

        this.addNotifyFormEventHandler();
    }

    addNotifyFormEventHandler() {
        if (this.form && this.isBISExists()) {
            const self = this;

            this.formObject.checkPrivacy.on('click', function (e) {
                self.validateCheckbox($(e.currentTarget),  window.Antonioli.languages.notifyFormPrivacyError);
            });

            this.formObject.email.on('change',function() {
                self.validateEmail();
            });

            // Gestione submit del form
            this.form.off('submit');
            this.form.on('submit', function(e){
                e.preventDefault();

                if (self.checkFormFields()) {
                    self.createBIS();
                    return true;
                }

                return false;
            });
        }
    }

    /**
    * Verifica se esiste l'oggetto globale BIS dell'app
    */
    isBISExists (){
        return  typeof(BIS) !== undefined;
    }

    /**
    * Verifica se la checkbox iscrizione newsletter è stata inserita
    */
    checkAcceptMarketing () {
        return (this.acceptsMarketing.length == 1 && this.acceptsMarketing.is(':checked') );
    }

    /**
    * Crea la richiesta Back In Stock
    * * Svuota il messaggio in coda
    * * é Avvia la promise al BIS
    * * Se la chiamata ajax va in errore, nasconde il loading generico e crea un waring nella console
    */
    createBIS () {
        this.setBisMessageError('');
        this.setBisMessageSuccess('');

        // Crea gli attributi extra per il BIS
        let attributes = {
            accepts_marketing: this.checkAcceptMarketing()
        };

        let bisPromise = BIS.create(this.getEmail(),
            this.idVariant,
            this.idProduct,
            attributes
        );

        bisPromise.then(this.createBISCallBack.bind(this), function(data) {
            console.log('Error BIS Create ' + data);
        });
    }

    /**
    * Verifica se abbiamo gestito la traduzione per il messaggio restituito dal BIS, nel caso non esiste stampiamo la stringa ricevuta
    *
    * @param {*} key Chiave relativa al messaggio (Per una chiave possiamo avere più messaggi)
    * @param {*} msg Messaggio da ricercare nella chaive Key
    */
    matchMessageTranslation(key, msg) {
        let retString = msg;

        /**
        * Veririca la chiave inviata dal BIS
        */
        if (key == "product_id") {
            if (msg ===  "The product_id parameter must contain the selected product id.") {
                // {% comment %} retString = SlamJam.strings.notify_form.message_errors.product_id.select_variant; {% endcomment %}
                debugger;
            }
        }

        return retString;
    }

    /**
    * Call Back richiamata dalla pronmise che invia i dati al BIS
    * @param {*} data
    */
    createBISCallBack (data) {
        let statusError=false; // Stato della risposta
        let msg = '';   // Messaggio da inserire in coda

        if (data.status == 'OK') {
            msg = data.message;
            this.setBisMessageError('');
            this.setBisMessageSuccess( window.Antonioli.languages.notifyFormSuccess);
            this.clearFields();

        } else { // it was an error
            statusError = true;
            let composedMessage = '';
            for (var k in data.errors) {  // collect all the error messages into a string
                if (msg.trim()!="") msg = msg + ", ";
                /**
                * Per i messaggi noti utilizziamo le traduzioni
                */
                if (k === "product_id") {
                    /** Estrate le traduzioni per tutti i messaggi ritornati dal BIS */
                    for (let im = 0; im < data.errors[k].length; im++) {
                        composedMessage += matchMessageTranslation(k, data.errors[k][im]);
                    }
                } else {
                    composedMessage = data.errors[k].join()+ "<br>"; // Join di tutti i  messaggi presenti nella chiave
                }

                msg += composedMessage;
            }

            this.setBisMessageError(msg);
            this.setBisMessageSuccess('');
        }

        // Nasconde il blocco form se la chiamata è andata a buon fine
        if (!statusError) {
            this.form.hide();
        }
    }

    clearFields() {
        this.dom.find('input[type=email]').val('');
        this.dom.find('input[type=text]').val('');
        this.dom.find('input:checkbox').prop('checked', false);
    }

    /**
    * @param {string} msg
    */
    setBisMessageError(msg) {
        if (this.bisResponseError && this.bisResponseError.length == 0 )  return ;

        this.bisResponseError.html(msg);

        if (msg.trim() !== '') {
            this.bisResponseError.show();
        } else {
            this.bisResponseError.hide();
        }
    }

    /**
    *
    * @param {*} msg
    */
    setBisMessageSuccess(msg) {
        if (this.bisResponseSuccess && this.bisResponseSuccess.length == 0 )  return ;
        this.bisResponseSuccess.html(msg);

        if (msg.trim() !== '') {
            this.bisResponseSuccess.show();
        } else {
            this.bisResponseSuccess.hide();
        }
    }

    /**
    * Estrae la mail inserita dall'utente nell'input
    */
    getEmail() {
        if (this.formObject.email.length == 1)  {
            return this.formObject.email.val();
        }

        return null;
    }

    //#region Validate Email(s)
    validateEmail () {
        let errors = false;

        let domObject = this.formObject.email;
        let email = this.formObject.email.val();

        if (email.trim() === '') {
            this.errorShow(domObject, window.Antonioli.languages.notifyFormCompileEmailError);
            errors = true;
        } else if (!this.validateEmail1(email)) {
            this.errorShow(domObject, window.Antonioli.languages.notifyFormEmailNotValidError);
            errors = true;
        } else {
            this.errorHide(domObject);
        }

        return !errors;
    }
    //#endregion

    validateEmail1 (email) {
        if (/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()\.,;\s@\"]+\.{0,1})+([^<>()\.,;:\s@\"]{2,}|[\d\.]+))$/.test(email)) {
            return true;
        }

        return email ? false : true;
    }

    validateCheckbox(objCheckbox, text) {

        for (let i = 0; objCheckbox.length; i++) {
            if (objCheckbox.prop('checked') === true) {
                this.errorHide(objCheckbox);
                $(objCheckbox[i]).prop( "checked" );

                return true;
            }

            this.errorShow(objCheckbox, text);

            return false;
        }
    }

    /**
    * Aggiunge la classe errore all'oggetto obj
    * @param {*} obj
    */
    errorShow(obj, text = null) {
        obj.addClass(this.cssInputClassError);

        if(text) {
            obj.parent().find('.form-fld-error').html(text);
        }

        obj.parent().find('.form-fld-error').removeClass(this.cssHideClass);
    }

    /**
    * Nasconde l'errore
    */
    errorHide(obj) {
        obj.removeClass(this.cssInputClassError);
        obj.parent().find('.form-fld-error').addClass(this.cssHideClass);
    }

    /**
    * Avvia un check preventivo prima dell'invio del form
    */
    checkFormFields() {
        let checkEmail = this.validateEmail();
        let checkPrivacy = this.validateCheckbox(this.formObject.checkPrivacy, window.Antonioli.languages.notifyFormPrivacyError);

        return checkEmail && checkPrivacy;
    }
}

customElements.define('product-countdown', productCountdown);
